import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { ResponseServiceModel } from '../models/response-service.model';
import { EnviromentGlobalService } from './enviroment-global.service';

@Injectable({
  providedIn: 'root'
})
export class BaseServiceService {
  private API_URL;

  constructor(
    private http: HttpClient,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  getActividadesEconomicasParaFuncionario(
    entry: any
  ): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/ActividadEconomicaPrestador/ParaFuncionario/${entry}`
      )
      .pipe(retry(2));
  }

  getActividadesEconomicasEstablecimientos(numero_identificacion, digito_verificacion, codigo_camara, numero_matricula): Observable<any> {
    return this.http
      .get(
        `${this.API_URL}/Establecimiento/ObtenerActividadesEconomicasEstablecimiento?numero_identificacion=${numero_identificacion}&digito_verificacion=${digito_verificacion}&codigo_camara=${codigo_camara}&numero_matricula=${numero_matricula}`
      ).pipe(retry(2))
  }

  getActividadesEconomicasPrestador(nombrePrestador: string) {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/ActividadEconomicaPrestador/actividadeseconmicasprestador/${nombrePrestador}`
      )
      .pipe(retry(2));
  }

  // Solo para funcionarios
  getActividadesEconomicasPrestadorFuncionario(numeroIdentificacion, digitoVerificacion): Observable<any> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/ActividadEconomicaPrestador/ParaFuncionario?numero_identificacion=${numeroIdentificacion}&digito_verificacion=${digitoVerificacion}`
      )
      .pipe(retry(2));
  }

  sincronizacionActividadesEconimicas(
    entry: any
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Prestador/SincronizarActividadesEconomicas`,
        entry
      )
      .pipe(retry(2));
  }

  // Create - Capacidad Tecnica
  createCapacidadTecnica(request) {
    return this.http.post<any>(
      `${this.API_URL}/RequisitosGeneralesAdministrador/Crear`,
      request
    )
      .pipe(retry(2));
  }
  // Read - Capacidad Tecnica
  readCapacidadTecnica(request, paginaActual) {
    return this.http.post<any>(
      `${this.API_URL}/RequisitosGeneralesAdministrador/Paginado?PageNumber=${paginaActual}&PageSize=12`,
      request
    )
      .pipe(retry(2));
  }
  // Update - Capacidad Tecnica
  updateCapacidadTecnica(request) {
    return this.http.put(
      `${this.API_URL}/RequisitosGeneralesAdministrador/Actualizar`,
      request
    ).pipe(retry(2));
  }
  // Delete - Capacidad Tecnica
  deleteCapacidadTecnica(idCapacidadTecnica) {
    return this.http.delete<any>(
      `${this.API_URL}/RequisitosGeneralesAdministrador/${idCapacidadTecnica}`
    )
      .pipe(retry(2));
  }

  // Listado categorias
  getCategory() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Categoria`
      )
      .pipe(retry(2));
  }

  getSubcategoryByIdCat(id: string) {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Subcategoria/PorCategoria/${id}`
      )
      .pipe(retry(2));
  }

  // Listado subcategorias
  getSubCategory() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/SubCategoria`
      )
      .pipe(retry(2));
  }

  // Listado Departamentos
  getDepartamento() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Departamento`
      )
      .pipe(retry(2));
  }

  // Listado municipio
  getMunicipio() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Municipio`
      )
      .pipe(retry(2));
  }

  // Listado municipio by ID Dpto
  getMunicipioByIdDpto(idDepartamento) {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Municipio/PorDepartamento/${idDepartamento}`
      )
      .pipe(retry(2));
  }

  // Listado de camaras de comercio
  getCamaraComercio() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/CamaraComercio`
      )
      .pipe(retry(2));
  }

  // Listado Tipo Solicitud
  getTipoSolicitud() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/GetTipoSolicitudes`
      )
      .pipe(retry(2));
  }

  // Listado Estado Solicitud
  getEstadoSolicitud() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/EstadosSolicitud`
      )
      .pipe(retry(2));
  }

  // Listado Estado RNT
  getEstadoRnt() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/EstadosRnt`
      )
      .pipe(retry(2));
  }

  getMunicipioPorCamara(entry: any): Observable<ResponseServiceModel> {
    return this.http.post<ResponseServiceModel>(`${this.API_URL}/Municipio/ObtenerTodosReporte`, entry).pipe(
      retry(2)
    );
  }

  // Listado Departamentos Por Camara
  getDepartamentosPorCamara(entry: any): Observable<ResponseServiceModel> {
    return this.http.post<ResponseServiceModel>(`${this.API_URL}/Departamento/ObtenerTodosReporte`, entry).pipe(
      retry(2)
    );
  }

  // Listado Convenciones Direccion
  getConvencionesDireccion() {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Direccion/ConvencionesDireccion`
      )
      .pipe(retry(2));
  }

  getConfiguracionDireccionEstandar(solicitud_id: string) {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/${solicitud_id}/ConfiguracionDireccionEstandar`
      )
      .pipe(retry(2));
  }
}
